import HTTPClient from '@/common/http-client';
import { LoginResponse } from '@/common/model/response/login-response.model';
import AppConstants from '@/common/constants/app.constants';
import { UserResponse } from '@/common/model/response/user-response.model';
import { LoginRequest } from '@/common/model/request/login-request.model';
import { GeneralDataResponse } from '@/common/model/response/general-response.data.model';
import store from '../store';
import ErrorMessageUtils from '../utils/error-message.util';
import ErrorCdMsgConstants from '../constants/error-cd-msg.constants';
const DEFAULT_ERROR_MSG = 'Failed to login';
export default class AuthService {
  async login(loginRequest: LoginRequest): Promise<string | null> {
    // Send request to authentication server (refer to vue.config.js file for proxy configuration)
    const response = await HTTPClient.getInstance().httpLogin.post<LoginResponse>(
      `${AppConstants.LOGIN_API_URL}`,
      loginRequest
    );
    const data = response.data;
    if (!data) {
      return DEFAULT_ERROR_MSG;
    }
    // Return error message if any
    if (data.code === 401 || data.code === 500) {
      return ErrorMessageUtils.buildErrorMessage(
        ErrorCdMsgConstants.FUNC_AUTH_ERR_CD,
        ErrorCdMsgConstants.FUNC_AUTH_ERR_MSG
      );
    }

    // Store token in the storage if it's available
    if (data.token) {
      localStorage.setItem(AppConstants.STORAGE_TOKEN, data.token);
      return null;
    }

    return DEFAULT_ERROR_MSG;
  }

  logout(): void {
    localStorage.removeItem(AppConstants.STORAGE_TOKEN);
    localStorage.removeItem(AppConstants.STORAGE_USER_DETAILS);
  }

  getUserDetails(): UserResponse | null {
    const userJson = localStorage.getItem(AppConstants.STORAGE_USER_DETAILS);
    if (userJson) {
      return JSON.parse(userJson);
    }
    return null;
  }

  async fetchUserDetails(): Promise<UserResponse> {
    const origin = window.location.origin;
    const res = await HTTPClient.getInstance().httpUsers.get<GeneralDataResponse<UserResponse>>(
      `/verifyToken?origin=${origin}`
    );
    const userDetailResponse = HTTPClient.convertAxiosResponseToResponse(res);
    const user: UserResponse = {
      userName: userDetailResponse.data.userName,
      avatar: userDetailResponse.data.avatar,
      email: userDetailResponse.data.email,
      nickName: userDetailResponse.data.nickName,
      userId: userDetailResponse.data.userId
    };
    // Set userId in setting store after login success
    store.dispatch('SettingStore/updateUserId', userDetailResponse.data.userId, { root: true });
    localStorage.setItem(AppConstants.STORAGE_USER_DETAILS, JSON.stringify(user));
    return user;
    // const res = await this.http.get<GeneralDataResponse<User>>(`/users/info`);
    // return res.data.data;
  }
}
